import React, { useState, useEffect } from "react";
import { geckoGet } from "../../service/gecko";
import { Sparklines, SparklinesLine } from "react-sparklines";

const SparklineChartGecko = ({ poolAddress, network = "bsc" }) => {
  const [data, setData] = useState([]);
  const [chartColor, setChartColor] = useState("#ff5959");

  useEffect(() => {
    if (!poolAddress) return;
    const fetchData = async () => {
      try {
        const res = await geckoGet(
          `https://api.geckoterminal.com/api/v2/networks/${network}/pools/${poolAddress}/ohlcv/day?limit=7`,
          { headers: { Accept: "application/json;version=20230302" } },
        );
        const ohlcv = res.data?.data?.attributes?.ohlcv_list;
        if (ohlcv && ohlcv.length > 0) {
          const closes = ohlcv.map((candle) => candle[4]);
          setChartColor(
            closes[closes.length - 1] >= closes[0] ? "#59ff8b" : "#FF0000",
          );
          setData(closes);
        }
      } catch (error) {
        console.error("Error fetching GeckoTerminal OHLCV:", error);
      }
    };
    fetchData();
  }, [poolAddress, network]);

  return (
    <div>
      <Sparklines data={data} width={100} height={50}>
        <SparklinesLine color={chartColor} />
      </Sparklines>
    </div>
  );
};

export default SparklineChartGecko;
